import React, { useEffect, useRef} from "react";
import { Routes,Route, BrowserRouter as Router, useNavigate} from "react-router-dom";
import {RoutePaths} from './RoutePaths';
import PrivateRoutes from './PrivateRoutes';
import Login from "../pages/Login";
import OrganizationLogin from "../pages/OrganizationLogin";
import ForgotPassword from '../pages/ForgotPassword';
import UpdatePassword from '../pages/UpdatePassword';
import CompleteProfile from '../pages/CompleteProfile';
import TwoStepVarification from '../pages/TwoStepVarification.jsx';
import NotFound from '../pages/NotFound';
import Upload from "../pages/Upload";
import PrivateAuthRoutes from "./PrivateAuthRoutes";
import ProfileCompletionForm from '../pages/ProfileCompletionForm';
import LoginRedirection from '../pages/LoginRedirection';
import PardotAuthCallBack from '../pages/PardotAuthCallBack';
import LogoutRedirection from '../pages/LogoutRedirection';

const CustomRouter = () => {

    return (
        
        <Router>
            
            <Routes >
              <Route element={<PrivateRoutes />}>
                {
                    RoutePaths.map((route,index) => 
                        <Route element={<PrivateAuthRoutes authUrl={route.path} permission={route.permission} key={route.path}/>} key={route.path}>
                            <Route key={route.path} path={route.path} element={route.element} />
                        </Route>
                    )
                }
                </Route>
                <Route element={<OrganizationLogin/>} path="/sso" />
                <Route element={<ForgotPassword/>} path="/forgot-password"/>
                <Route element={<UpdatePassword/>} path="/unauth/verify-password"/>
                <Route element={<ProfileCompletionForm/>} path="/unauth/complete-profile"/>
                <Route element={<CompleteProfile/>} path="/unauth/verify-newuser"/>
                <Route element={<LoginRedirection/>} path="/unauth/login-redirect"/>
                <Route element={<TwoStepVarification/>} path="/two-step-varification"/>
                <Route element={<NotFound />} path ="/not-found" />
                <Route element={<NotFound />} path ="*" />
                <Route element={<Upload />} path ="/upload" />
                <Route element={<PardotAuthCallBack/>} path="/oauth/pardotcallback.json"/>
                <Route element={<LogoutRedirection/>} path="/logout"/>
            </Routes>

        </Router>
    );
}

export default CustomRouter;